export default {
  stats: {
    table: {
      rank: "Rank",
      name: "Name",
    },
    legend: {
      title: "Legend",
    },
    filters: {
      titles: {
        week: "Week",
        round: "Round",
        split: "Split",
      },
      options: {
        all: "All",
        qualifier: {
          cumulativeStats: "Total",
          perGame: "Per Game",
        },
      },
    },
  },
};